import type { MarkNotificationAsFailed200BasicInfoType } from './markNotificationAsFailed200BasicInfoType';

export type MarkNotificationAsFailed200BasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: MarkNotificationAsFailed200BasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
